import angular from 'angular';
import NotFoundPageComponent from './not-found-page.component';


const notFoundPage = angular.module('ttb.widgets.notFoundPage', [])
    .component('notFoundPage', NotFoundPageComponent)
    .name;

export default notFoundPage;


// WEBPACK FOOTER //
// ../widgets/not-found-page/index.js